/**
 * 改行を反映されるようにテキストを変換
 */
export const ConvertNewlinesToBr = (text: string) => {
  return text.split("\n").map((line, index) => (
    <span key={index}>
      {line}
      <br />
    </span>
  ));
};
